import React from 'react';
import ReactDOM from 'react-dom';
import './i18n/config';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { UserContextProvider } from './context/user-context';
import 'typeface-roboto';
import { SearchContextProvider } from './context/search-context';
import { QuestionnaireContextProvider } from './context/questionnaire-context';
import { CustomerContextProvider } from './context/customer-context';
import './assets/fonts/Mark-Pro.ttf';

ReactDOM.render(
  <UserContextProvider>
    <SearchContextProvider>
      <CustomerContextProvider>
        <QuestionnaireContextProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QuestionnaireContextProvider>
      </CustomerContextProvider>
    </SearchContextProvider>
  </UserContextProvider>,
  document.getElementById('root'),
);

